import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d2d8ffc8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { align: "center" }
const _hoisted_2 = {
  class: "imprint",
  align: "start",
  style: {"font-family":"Verdana, Geneva, Tahoma, sans-serif"}
}
const _hoisted_3 = {
  class: "mt-10",
  style: {"font-size":"xxx-large"}
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = { style: {"font-size":"xx-large"} }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = { href: "mailto:paras@dwivedi.eu" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import FooterComponent from "@/components/Footer/FooterComponent.vue"
import HeaderComponent from "@/components/Header/HeaderComponent.vue"
import { computed } from "vue"
import { useI18n } from "vue-i18n"
import { useMeta } from "vue-meta"

export default /*#__PURE__*/_defineComponent({
  __name: 'ImprintComponent',
  setup(__props) {

FooterComponent
const { t } = useI18n()
useMeta(
  computed(() => ({
    title: t("meta.imprint"),
  }))
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(HeaderComponent),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t('imprint.title')), 1),
        _hoisted_4,
        _createElementVNode("div", null, [
          _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.$t('imprint.legal_info')), 1),
          _hoisted_6,
          _createTextVNode(" " + _toDisplayString(_ctx.$t('imprint.company_name')), 1),
          _hoisted_7,
          _createTextVNode(" " + _toDisplayString(_ctx.$t('imprint.street')), 1),
          _hoisted_8,
          _createTextVNode(" " + _toDisplayString(_ctx.$t('imprint.city_code')) + " ", 1),
          _hoisted_9,
          _createElementVNode("a", _hoisted_10, _toDisplayString(_ctx.$t('imprint.email')), 1),
          _hoisted_11
        ]),
        _hoisted_12,
        _createElementVNode("div", null, [
          _createElementVNode("h3", null, _toDisplayString(_ctx.$t('imprint.represented_by')), 1),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('imprint.representative')), 1),
          _hoisted_13
        ]),
        _hoisted_14,
        _createElementVNode("div", null, [
          _createElementVNode("h3", null, _toDisplayString(_ctx.$t('imprint.registration')), 1),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('imprint.register_entry')), 1),
          _hoisted_15,
          _createTextVNode(" " + _toDisplayString(_ctx.$t('imprint.register_court')), 1),
          _hoisted_16,
          _createTextVNode(" " + _toDisplayString(_ctx.$t('imprint.register_number')), 1),
          _hoisted_17
        ]),
        _hoisted_18,
        _createElementVNode("div", null, [
          _createElementVNode("h3", null, _toDisplayString(_ctx.$t('imprint.vat_id_title')), 1),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('imprint.vat_id')), 1),
          _hoisted_19
        ]),
        _hoisted_20,
        _createElementVNode("div", null, [
          _createElementVNode("h3", null, _toDisplayString(_ctx.$t('imprint.responsible_content')), 1),
          _hoisted_21,
          _createTextVNode(" " + _toDisplayString(_ctx.$t('imprint.responsible_person')) + " ", 1),
          _hoisted_22,
          _createTextVNode(" " + _toDisplayString(_ctx.$t('imprint.responsible_street')), 1),
          _hoisted_23,
          _createTextVNode(" " + _toDisplayString(_ctx.$t('imprint.responsible_city')) + " ", 1),
          _hoisted_24
        ]),
        _hoisted_25,
        _createElementVNode("div", null, [
          _createElementVNode("h3", null, _toDisplayString(_ctx.$t('imprint.disclaimer')), 1),
          _createElementVNode("h3", null, _toDisplayString(_ctx.$t('imprint.liability_content')), 1),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('imprint.liability_content_text')) + " ", 1),
          _hoisted_26,
          _hoisted_27,
          _createElementVNode("h3", null, _toDisplayString(_ctx.$t('imprint.liability_links')), 1),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('imprint.liability_links_text')) + " ", 1),
          _hoisted_28,
          _hoisted_29,
          _createElementVNode("h3", null, _toDisplayString(_ctx.$t('imprint.copyright')), 1),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('imprint.copyright_text')), 1)
        ])
      ])
    ]),
    _createVNode(FooterComponent)
  ], 64))
}
}

})